import { useState, useEffect, useCallback, useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import "../NewmasterPage/Master.css"
import '../../components/table.css';
import styles from "../transaction/transaction.module.css"
import searchicon_black from "../../icons/searchicon_black.png"
import style from "../../components/Search&Options/Search&Options.module.css"
import Order from "../order";
import moment from "moment"
import CircularProgress from '@mui/material/CircularProgress';
import * as XLSX from 'xlsx';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import "../../index.css"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


//import { toast } from "react-toastify";
const { apiEndpoint, baseNodeapiUrl } = config;

var $ = require('jquery');

// const badgeMaker: any = {
//     "Created": (order_state: any) => <span className="badge badge-primary">{order_state}</span>,
//     "Shipped": (order_state: any) => <span className="badge badge-warning">{order_state}</span>,
//     "Delivered": (order_state: any) => <span className="badge badge-success">{order_state}</span>,
//     "Canceled": (order_state: any) => <span className="badge badge-danger">{order_state}</span>,
// }

const OrderList = () => {
    const decoded: any = tokenDecode();
    const current_seller_id = decoded?.data?.user?.seller_id
    const [orderList, setOrderList] = useState<any[]>([]);
    const [sorderList, setSorderList] = useState<any[]>([]);

    const [sellerList, setSellerList] = useState([]);
    const [otherData, setOtherData] = useState<any[]>([]);
    const [updateOrder_, setUpdateOrder_]: any = useState({
        order_id: "",
        tracking_url: "",
        order_state: ""
    })
    const [orderDetail, setorderDetail]: any = useState([]);
    const [_orderDetail, _setorderDetail]: any = useState({
        billing_address: "",
        contact_number: "",
        created_at: "",
        email: "",
        id: '',
        name: "",
        order_id: "",
        order_state: "",
        provider_id: "",
        shipping_address: "",
        status: "",
        total_price: 0
    });
    const rawData = {
        provider_id: ''
    }
    const Sstyle = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "10px",
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 2,
    };
    const [toggle, setToggle] = useState(false);
    const [searchData, setSearchData]: any = useState(rawData);

    const [valuename, setValuename] = useState("");
    const [valueid, setValueid] = useState("");
    const [valueemail, setValueemail] = useState("");
    const [valuecontact, setValuecontact] = useState("");
    const [valuestatus, setValuestatus] = useState("");
    const [valueamount, setValueamount] = useState("");
    const [valuedate, setValuedate] = useState("");
    const [orderisLoading, setorderisLoading] = useState(true);
    const [allorders, setallorders] = useState([])
    const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
    const [updateorderstatus, setupdateorderstatus] = useState(false);
    const [exportOrderModalOpen, setexportOrderModalOpen] = useState(false);
    const [fraudModalOpen, setfraudModalOpen] = useState(false);
    const [isAnalyzing, setisAnalyzing] = useState(false)
    const [fraudLevel, setfraudLevel] = useState("");
    const [selectedCities, setSelectedCities] = useState<any>([]);
    const [singleSellerSelect, setsingleSellerSelect] = useState("");
    const [exportOrdersFilterState, setexportOrdersFilterState] = useState({
        month: "",
        year: ""
    })
    const { data } = decoded;
    const { permission: { seller, order } } = data;
    const [filterDaata, setfilterDaata] = useState({
        seller_id: "",
        orderCurrentStatus: "",
        endDate: ""
    })
    const [fraudDaata, setfraudDaata] = useState({
        provider_id: "",
        start_date: "",
        end_date: "",
        limit_count: "",
        limit_price: ""
    })

    function fraudChangeHandler(e: any) {
        setfraudDaata((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }

    var count = 1;
    function handleShipementModalClose() {
        setshipmentModalOpen(false)
    }
    function handleExportOrderModalClose() {
        setexportOrderModalOpen(false)
    }
    function handleFraudModalClose() {
        setfraudModalOpen(false)
    }

    function onDateandYearChangeHandler(e: any) {
        setexportOrdersFilterState((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }
    const [nextstep, setnextstep] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [showPages, setShowPages] = useState(true);

    const [rawOrders, setRawOrders] = useState<any[]>([]);
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
    const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
    const [statusSearchTerm, setStatusSearchTerm] = useState("");
    const [searchOrderId, setSearchOrderId] = useState("");
    const [debouncedSearchOrderId, setDebouncedSearchOrderId] = useState("");

    const statusDropdownRef = useRef<HTMLDivElement>(null);
    const statusOptions = ["Created", "Accepted", "In-progress", "Completed", "Cancelled"];

    // Close status dropdown on click outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target as Node)) {
                setStatusDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Debounce Search Order ID
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchOrderId(searchOrderId);
            setnextstep(1);
        }, 400);
        return () => clearTimeout(timer);
    }, [searchOrderId]);

    const fetchOrders = useCallback(async (
        orderStateParam: string = "",
        orderIdParam: string = "",
        pageParam: number = nextstep,
        limitParam: number = pageSize
    ) => {
        setorderisLoading(true);
        try {
            const bodyPayload: any = {
                page: pageParam,
                limit: limitParam,
            };
            if (orderStateParam) {
                bodyPayload.order_state = orderStateParam;
            }
            if (orderIdParam && orderIdParam.trim() !== "") {
                bodyPayload.order_id = orderIdParam.trim();
            }

            const { data } = await axios({
                url: `${apiEndpoint}/snp/orders/getallorders?page=${pageParam}&limit=${limitParam}`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: bodyPayload
            });
            if (data.status === true || data.status === 200 || data.status === "200") {
                const list = data.orders || data.data || [];
                setRawOrders(list);
                setOrderList(list);
                setSorderList(list);

                if (data.pagination) {
                    const resPage = data.pagination.page || data.pagination.currentPage || pageParam;
                    const resLimit = data.pagination.limit || data.pagination.pageSize || limitParam;
                    const resTotal = data.pagination.total_count ?? data.pagination.totalRecords ?? list.length;
                    const resPages = data.pagination.total_pages || data.pagination.totalPages || Math.ceil(resTotal / resLimit) || 1;

                    setnextstep(resPage);
                    setPageSize(resLimit);
                    setTotalCount(resTotal);
                    setTotalPages(resPages);
                } else {
                    setTotalCount(list.length);
                    setTotalPages(Math.ceil(list.length / limitParam) || 1);
                }
            } else {
                setRawOrders([]);
                setOrderList([]);
                setSorderList([]);
                setTotalCount(0);
                setTotalPages(1);
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
            setRawOrders([]);
            setOrderList([]);
            setSorderList([]);
            setTotalCount(0);
            setTotalPages(1);
        } finally {
            setorderisLoading(false);
        }
    }, [nextstep, pageSize]);

    const fetchSellerList = useCallback(() => {
        fetchOrders("", "", nextstep, pageSize);
    }, [fetchOrders, nextstep, pageSize]);

    useEffect(() => {
        let paramState = "";
        if (selectedStatuses.length === 1) {
            paramState = selectedStatuses[0];
        }
        fetchOrders(paramState, debouncedSearchOrderId, nextstep, pageSize);
    }, [selectedStatuses, debouncedSearchOrderId, nextstep, pageSize]);

    const handleStatusToggle = (status: string) => {
        setnextstep(1);
        setSelectedStatuses((prev) =>
            prev.includes(status) ? [] : [status]
        );
    };

    // const [exceldataLoading, setexcelDataLoading] = useState(false)
    const allorderList = async () => {
        if (!startDate || !endDate) return;

        const formatDate = (date: Date) =>
            `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getallstatusorder`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    // seller_id: decoded?.data?.user?.seller_id,
                    startDate: formattedStartDate, // send as DD-MM-YYYY
                    endDate: formattedEndDate,
                    // exportType,     // send as DD-MM-YYYY
                },

            });
            console.log("daty26378_>>>", data)

            if (data.status === "success") {
                console.log("start export ")
                setallorders(data.data);
                exportToExcel(data.data);
                console.log("start export 222222")

            }
        } catch (error) {
            console.log("error", error);
        }
    };
    const updateOrder = async (order_id: any) => {
        try {

            const { data } = await axios({
                url: `${apiEndpoint}/updateorderstatus`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: updateOrder_
            });
            // console.log(data, "datadata");

            if (data.message === "flag1") {
                toast.success("Order updated !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                // fetchSellerList();
            } else {
                toast.error("Something went wrong !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }

        } catch (error) {
            console.log("update error", error);
            toast.error("404 error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            // window.location.reload();

        }
    }

    const getSellerList = async () => {
        fetchOrders("", "", nextstep, pageSize);
    };
    const inputHandler = async (e: any) => {
        setValuename("");
        setValueid("");
        setValueemail("");
        setValuecontact("");
        setValuestatus("");
        setValueamount("");
        setValuedate("");
        var optionvalue = e.target.value;
        if (optionvalue) {
            try {
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbyseller`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        provider_id: optionvalue
                    }

                });

                if (data.status === 200) {
                    // console.log(data);
                    setOrderList(data.data);
                    setSorderList(data.data);
                    setToggle(true)
                }


            } catch (error) {
                console.log("error", error);
            }
        }
        else {
            setOrderList(sorderList);
        }
    };
    const inputeHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValuename(optionvalue);
        if (optionvalue) {
            try {
                const {
                    provider_id
                } = searchData;
                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        provider_id: { searchData },
                        name: optionvalue
                    }

                });


                if (data.status === 200) {
                    // console.log(data);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    };
    const inputeeHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuename(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        name: optionvalue
                    }

                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputoHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValueid(optionvalue);
        if (optionvalue) {
            try {
                setToggle(true);
                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data:
                    {
                        // provider_id: { searchData },
                        order_id: optionvalue
                    }

                });

                if (data.status === 200) {
                    setOrderList(data.response);
                    // console.log("line 332", data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
            fetchSellerList()
        }
    };
    const inputooHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValueid(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        order_id: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputemHandler = async (e: any) => {

        const optionvalue = e.target.value;
        // console.log(optionvalue)
        setValueemail(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        email: optionvalue
                    }

                });

                if (data.status === 200) {
                    setOrderList(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    };
    const inputeemHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValueemail(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        email: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputcHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValuecontact(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        contact_number: optionvalue
                    }

                });

                if (data.status === 200) {
                    setOrderList(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    };
    const inputccHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuecontact(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        contact_number: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputpHandler = async (e: any) => {

        const optionvalue = e.target.value;
        // console.log(optionvalue)
        setValuestatus(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        status: optionvalue
                    }

                });

                if (data.status === 200) {
                    setOrderList(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }


    };


    const inputOrderStatusHandler = async (e: any) => {

        const optionvalue = e.target.value;
        // console.log(optionvalue)
        setValuestatus(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data:
                    {
                        provider_id: searchData?.provider_id,
                        order_state: optionvalue
                    }

                });

                if (data.status === 200) {
                    setOrderList(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }


    };
    const inputppHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuestatus(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        status: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };

    const inputOOrderStatusHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuestatus(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        order_state: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    };
    const inputaHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValueamount(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        order_total: optionvalue
                    }

                });

                if (data.status === 200) {
                    setOrderList(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    }
    const inputaaHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValueamount(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        order_total: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    }
    const inputdHandler = async (e: any) => {

        const optionvalue = e.target.value;
        setValuedate(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);

                //setSearchpData({ ...searchpData, [e.target.name]: e.target.value });
                //console.log("line 239"+rawpData);
                const { data } = await axios({
                    url: `${apiEndpoint}/filterbysellerorder`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data:
                    {
                        provider_id: { searchData },
                        created_at: optionvalue
                    }

                });

                if (data.status === 200) {
                    setOrderList(data.response);
                    // console.log(data.response)
                }


            } catch (error) {
                console.log("error", error);
            }
        } else {
            inputHandler(e);
        }
    }
    console.log("orderList------->", orderList)
    const inputddHandler = async (e: any) => {
        const optionvalue = e.target.value;
        setValuedate(optionvalue);
        if (optionvalue) {
            try {

                setToggle(true);
                setSearchData({ ...searchData, [e.target.name]: e.target.value });
                const { data } = await axios({
                    url: `${apiEndpoint}/filterordersellerlogin`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: {
                        created_at: optionvalue
                    }
                });

                if (data.status === 200) {
                    // console.log(data.response);
                    setOrderList(data.response);

                }

            } catch (error) {
                console.log("error", error);
            }
        } else {
            fetchSellerList();
        }
    }

    const COLUMNS = [
        {
            Header: "Serial No.",
            Footer: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Order ID",
            Footer: "Order ID",
            accessor: "order_id",
            sticky: "left"
        },
        {
            Header: "Order Status",
            Footer: "Order Status",
            accessor: "order_state",
            sticky: "left",

        },
        {
            id: 'sellerNameColumn',
            Header: () => (
                <div>
                    <select name="" value={singleSellerSelect} id="" style={{ color: "white", border: "none", width: "125px", textAlign: 'center' }} onChange={(e) => {
                        setsingleSellerSelect(e.target.value);
                        setfilterDaata((prev) => (
                            { ...prev, seller_id: e.target.value }
                        ))
                    }}>
                        <option value="" style={{ background: "#001ad5" }} disabled > Seller Name</option>
                        {
                            sellerList.map((item: any) => (
                                <option value={item?.seller_id} key={item?.seller_id} style={{ background: "#001ad5" }}>{item?.name}</option>
                            ))
                        }
                    </select>

                </div>
            ),
            Footer: "Seller Name",
            accessor: (row: any) => {
                let sellerName = row?.address?.start?.location?.descriptor?.name
                if (sellerName) {
                    return sellerName
                } else {
                    const parsedData = JSON.parse(row?.fulfillments);
                    const selletName = parsedData[0]?.start?.location?.descriptor?.name

                    return selletName
                }
            },
            sticky: "left"
        },
        {
            Header: "Ageing (in days)",
            Footer: "Ageing",
            accessor: (row: any) => {
                if (row.order_state === "Completed" || row.order_state === "Cancelled") {

                    var date1 = moment(row.created_at);
                    var date2 = moment(row.updated_at);
                    var days = date2.diff(date1, 'days')
                    return days
                } else {

                    var date1 = moment(row.created_at);
                    var date2 = moment(new Date());
                    var days = date2.diff(date1, 'days')
                    return days
                }

            },
            sticky: "left"
        },
        {
            Header: "Customer name",
            Footer: "Customer name",
            accessor: "name",
            sticky: "left"
        },
        {
            Header: "Total (In Rs)",
            Footer: "Total",
            accessor: "order_total",
            sticky: "left"
        },
        {
            Header: "Payment Status",
            Footer: "Payment Status",
            accessor: (row: any) => {
                return <>{row.status === "NOT-PAID" ? "COD" : "PAID"}</>
            },
            sticky: "left"
        },
        {
            Header: "Created Date",
            Footer: "Created Date",
            accessor: (row: any) => {
                if (row?.created_at) {
                    return moment.utc(row?.created_at).format("DD-MM-YYYY  HH:mm:ss")
                } else {
                    return ""
                }
            },
            sticky: "left"
        },
        {
            Header: "Tracking URL",
            Footer: "Tracking URL",
            accessor: "tracking_url",
            sticky: "left"
        },
        {
            Header: "shopify Order Id",
            accessor: (item: any) => (item?.shopify_order_id ? item?.shopify_order_id : ""),
            sticky: "left"
        },

        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <div className="d-flex gap-2">

                        {/* Edit - Open Modal */}
                        <span
                            className="btn btn-warning btn-circle"
                            onClick={() => getorderDetailsByOrderID(row.order_id)}
                            style={{ cursor: "pointer" }}
                        >
                            <i className="fas fa-pen"></i>
                        </span>

                        {/* View - Redirect */}
                        <Link
                            to={`/orderCompleteDetail/${row.order_id}`}
                            className="btn btn-success btn-circle"
                        >
                            <i className="fas fa-eye"></i>
                        </Link>

                    </div>
                );
            },
            sticky: "left"
        },

    ];
    count++
    useEffect(() => {
        fetchSellerList();
        getSellerList();
        // allorderList()
        // getAllOrderList();
    }, [])
    useEffect(() => {
        if (selectedCities.length > 0 || singleSellerSelect !== "") {
            applyFilterHandler()
        } else {
            fetchSellerList()
        }

        // getAllOrderList();
    }, [selectedCities, singleSellerSelect])


    const exportToExcel = (orders: any[]) => {
        console.log("reacged in the function")
        if (!orders || orders.length === 0) return;
        console.log("cross barrier ")

        const headers = [
            "S.No",
            "Order Id",
            "Customer Name",
            "Customer Email",
            "Customer Contact",
            "Product Name",
            "Price",
            "Quantity",
            "Fulfillment State",
            "Tracking URL",
            "Created At",
            "Order State",
            "Product Id",
            "Shopify Order Id",
            "Brand Name",
            "Bap Id"
        ];

        const data = orders.map((order, index) => ({
            "S.No": index + 1,
            "Order Id": order.order_id,
            "Customer Name": order.name,
            "Customer Email": order.email,
            "Customer Contact": order.contact_number,
            "Product Name": order.product_name,
            "Price": order.price,
            "Quantity": order.quantity,
            "Fulfillment State": order.fulfillment_state,
            "Tracking URL": order.tracking_url || "-",
            "Created At": moment(order.created_at).format("DD-MM-YYYY hh:mm:ss"),
            "Order State": order.order_state,
            "Product Id": order.product_id,
            "Shopify Order Id": order.shopify_order_id,
            "Brand Name": order.brand_name,
            "Bap Id": order.bap_id
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });
        XLSX.utils.book_append_sheet(wb, ws, "Orders");
        XLSX.writeFile(wb, `orders_${new Date().getTime()}.xlsx`);
    };

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month: string | number = today.getMonth() + 1;
        let day: string | number = today.getDate();

        // Add leading zero if month or day is a single digit
        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    }

    async function filterChangeHandler(e: React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLInputElement>) {
        if (e.target.name !== "orderCurrentStatus") {
            setfilterDaata((prev) => {
                return { ...prev, [e.target.name]: e.target.value }
            })
        } else {
            setfilterDaata((prev: any) => {
                return { ...prev, orderCurrentStatus: e.target.value ? [e.target.value] : "" }
            })
        }
    }

    async function applyFilterHandler() {
        let payload;
        const currentStatus = Array.isArray(filterDaata.orderCurrentStatus)
            ? filterDaata.orderCurrentStatus
            : (filterDaata.orderCurrentStatus ? [filterDaata.orderCurrentStatus] : []);

        if (selectedCities.length > 0) {
            payload = {
                date: filterDaata.endDate,
                order_status: [...selectedCities],
                seller_id: filterDaata.seller_id
            }
        } else {
            payload = {
                date: filterDaata.endDate,
                order_status: currentStatus,
                seller_id: filterDaata.seller_id
            }
        }
        setorderisLoading(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/ordersfilter`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    // date: filterDaata.endDate,
                    // order_status: filterDaata.orderCurrentStatus,
                    // seller_id: filterDaata.seller_id
                    ...payload
                }

            });
            if (data.status === 200) {
                setOrderList(data.data);
                setshipmentModalOpen(false)
                setorderisLoading(false);

            }
        } catch (error) {
            setorderisLoading(false);
            console.log("error", error);
        }
    }

    const preventMinus = (e: any) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    async function analyzerFunction() {
        setfraudLevel("")
        try {
            setisAnalyzing(true)
            const { data } = await axios({
                url: `${baseNodeapiUrl}/analytics/fraudAnalytics_seller_order_count`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    ...fraudDaata
                }

            });
            if (data === "Low") {
                setfraudLevel("33%")
            }
            if (data === "Medium") {
                setfraudLevel("66%")
            }
            if (data === "High") {
                setfraudLevel("99%")
            }

            setisAnalyzing(false)
        } catch (error) {
            setisAnalyzing(false)
            console.log("error", error);
        }
    }

    const steps = [
        'Low',
        'Medium',
        'High',
    ];


    const allOptions = [
        "Created", "Accepted", "In-progress", "Completed", "Cancelled"
    ]
    const handleAutocompleteChange = (
        event: React.ChangeEvent<{}>,
        newSelectedCities: any
    ) => {
        setSelectedCities(newSelectedCities);
    };

    const [orderDetails, setOrderDetails] = useState(null);
    const [orderUpdateModal, setorderUpdateModal] = useState(false);
    const [orderStatus, setorderStatus] = useState([
        "Created",
        "Accepted",
        "In-progress",
        "Completed",

    ]);

    const [orderState, setOrderState] = useState<{
        order_id: string;
        order_state: string;
        fulfillment_state: string;
        tracking_url: string;
        invoice_url: string;
        agent_name?: string;
        agent_contact?: string;
    }>({
        order_id: "",
        order_state: "",
        fulfillment_state: "",
        tracking_url: "",
        invoice_url: "",
        agent_name: "",
        agent_contact: ""
    })
    console.log("sdfghjkl", orderState)
    const [isAgentNameReadOnly, setIsAgentNameReadOnly] = useState<boolean>(false);
    const [isAgentContactReadOnly, setIsAgentContactReadOnly] = useState<boolean>(false);
    const [isTrackingUrlReadOnly, setIsTrackingUrlReadOnly] = useState<boolean>(false);
    const [fieldErrors, setFieldErrors] = useState<{
        agent_name?: string;
        agent_contact?: string;
        tracking_url?: string;
    }>({});

    function handleOrderUpdateModalClose() {
        setOrderState({
            order_id: "", order_state: "", fulfillment_state: "", tracking_url: "", invoice_url: "", agent_name: "", agent_contact: ""
        });
        setFieldErrors({});
        setIsAgentNameReadOnly(false);
        setIsAgentContactReadOnly(false);
        setIsTrackingUrlReadOnly(false);
        setorderStatus(["Created", "Accepted", "In-progress", "Completed"])
        setshipmentModalOpen(false);
        setOrderDetails(null)
    }

    async function getorderDetailsByOrderID(order_id: string) {
        // let apiEndpoint =  baseUrlDefiner();
        setOrderState((prev) => {
            return { ...prev, order_id: order_id }
        })
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/orders/getOrderdetails/${order_id}`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                },
                // data: {
                //     order_id,
                // },
            });

            // console.log("setOrderDetails--------->", data.status);

            if (data.status == true) {
                setOrderDetails(data);
                const productObj = Array.isArray(data?.product) ? data?.product[0] : (data?.product || {});
                const orderObj = Array.isArray(data?.orders) ? data?.orders[0] : (data?.orders || {});

                const apiAgentName = productObj?.agent_name ?? orderObj?.agent_name ?? "";
                const apiAgentContact = productObj?.agent_contact ?? orderObj?.agent_contact ?? "";
                const apiTrackingUrl = productObj?.tracking_url ?? orderObj?.tracking_url ?? "";

                setIsAgentNameReadOnly(Boolean(apiAgentName && String(apiAgentName).trim() !== ""));
                setIsAgentContactReadOnly(Boolean(apiAgentContact && String(apiAgentContact).trim() !== ""));
                setIsTrackingUrlReadOnly(Boolean(apiTrackingUrl && String(apiTrackingUrl).trim() !== ""));

                let fulfillmentState = productObj?.fulfillment_state ?? "";
                if (!fulfillmentState && orderObj?.fulfillments) {
                    try {
                        const parsed = typeof orderObj.fulfillments === 'string' ? JSON.parse(orderObj.fulfillments) : orderObj.fulfillments;
                        fulfillmentState = parsed?.[0]?.state?.descriptor?.code || "";
                    } catch (e) { }
                }

                setOrderState((prev) => {
                    return {
                        ...prev,
                        order_state: orderObj?.order_state ?? "",
                        fulfillment_state: fulfillmentState,
                        tracking_url: productObj?.tracking_url ?? orderObj?.tracking_url ?? "",
                        invoice_url: orderObj?.invoice_url ?? "",
                        agent_name: productObj?.agent_name ?? orderObj?.agent_name ?? "",
                        agent_contact: productObj?.agent_contact ?? orderObj?.agent_contact ?? "",
                    }
                })
                if (data.orders[0].order_state !== "") {

                    const index = orderStatus.findIndex((item) => item === data.orders[0].order_state);

                    if (index !== -1) {
                        let slicedStatus = orderStatus.slice(index);

                        setorderStatus([...slicedStatus]);
                    }
                }
            } else {
                toast.error("Error getting order details!")
            }
            setorderUpdateModal(true)
        } catch (err) {
            toast.error("Something Went Wrong!!")
        }

    }

    const updateThisOrder = async (e: any) => {
        console.log(orderState);
        if (orderState?.fulfillment_state === "Agent-assigned") {
            const errors: { agent_name?: string; agent_contact?: string; tracking_url?: string } = {};

            if (!orderState?.agent_name || !orderState.agent_name.trim()) {
                errors.agent_name = "Agent Name is required";
            }
            if (!orderState?.agent_contact || !orderState.agent_contact.trim()) {
                errors.agent_contact = "Agent Contact is required";
            } else if (orderState.agent_contact.length !== 10) {
                errors.agent_contact = "Agent contact number must be exactly 10 digits!";
            }
            if (!orderState?.tracking_url || !orderState.tracking_url.trim()) {
                errors.tracking_url = "Tracking URL is required";
            } else if (!orderState.tracking_url.trim().startsWith("https://")) {
                errors.tracking_url = "Tracking URL must start with https://";
            }

            if (Object.keys(errors).length > 0) {
                setFieldErrors(errors);
                const firstErrorMessage = errors.agent_name || errors.agent_contact || errors.tracking_url;
                toast.error(firstErrorMessage);
                return;
            }
        }
        setFieldErrors({});
        const trackingUrl = (orderState?.tracking_url || "").trim();
        if (trackingUrl && !trackingUrl.startsWith("https://")) {
            toast.error("Tracking URL must start with https://");
            return;
        }
        // let apiEndpoint =  baseUrlDefiner();
        try {
            const token = sessionStorage.getItem('token');
            const { data } = await axios({
                url: `${apiEndpoint}/snp/orders/update_order`,
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
                data: orderState,
            });


            if (data.status === true || data.status === 200 || data.success === true) {

                if (orderState.order_state === "Created") {
                    toast.success("Order Created successfully!");
                } else if (orderState.order_state === "Accepted") {
                    toast.success("Order Accepted successfully!");
                } else if (orderState.order_state === "In-progress") {
                    toast.success("Order In-progress!");
                } else if (orderState.order_state === "Completed") {
                    toast.success("Order Completed successfully!");
                } else if (orderState.order_state === "Cancelled") {
                    toast.success("Order Cancelled successfully!");
                } else {
                    toast.success(data.message || "Order updated successfully!");
                }
                setorderUpdateModal(false);
                handleOrderUpdateModalClose();
                let paramState = "";
                if (selectedStatuses.length === 1) {
                    paramState = selectedStatuses[0];
                }
                fetchOrders(paramState, debouncedSearchOrderId || "", 1, 10);
            } else {
                toast.error(data?.message || data?.error || "Failed to update order.");
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message || error?.response?.data?.error || error?.message || "Failed to update order.");
        }
    };

    async function updatetrackingurl() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update-tracking-url`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    "delivered": true,
                    "one_data": false
                }
            });

            console.log("Update Order Response:", data);

        } catch (error) {
            console.error("Error updating order:", error);

        }
    }
    async function updateordershopify() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update-tracking-url`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    "all_orders": true,
                    "one_data": false
                }
            });

            console.log("Update Order Response:", data);

        } catch (error) {
            console.error("Error updating order:", error);

        }
    }
    async function updateordertrack() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update-tracking-url`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    "delivered": true,
                    "one_data": false
                }
            });

            console.log("Update Order Response:", data);

        } catch (error) {
            console.error("Error updating order:", error);

        }
    }

    const handleEdit = (orderId: string | number) => {
        console.log("Edit clicked for Order ID:", orderId);
        // Add your edit functionality here
        // Example: Open a modal or redirect
    };
    const handleView = (orderId: string) => {
        console.log("View clicked for Order ID:", orderId);
        // Example: Navigate to order details page
        // navigate(`../../orderCompleteDetail/${orderId}`);
    };
    const perPage = 10;




    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [openmodalbtn, setopenmodalbtn] = useState(false)
    const [endDate, setEndDate] = useState<Date | null>(new Date());
    const exportDisabled = !startDate || !endDate;

    const isDisabled = !startDate || !endDate;

    const [storefile, setStoreFile] = useState(null)

    const handleFile = (e: any) => {
        setStoreFile(e.target.files[0])
    }
    const handlemodalfile = (e: any) => {
        setStoreFile(e.target.files[0])
    }
    const handlemodalcancel = (e: any) => {
        setStoreFile(e.target.files[0])
    }
    const handlemodalupdate = (e: any) => {
        setStoreFile(e.target.files[0])
    }

    const Uploadfile = async () => {
        if (!storefile) {
            toast.error("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", storefile);

        try {
            const res = await axios.post(
                `${baseNodeapiUrl}/shiprocket/update_DB_completed_status`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,

                    },
                }
            );
            toast.success(res?.data?.message);
            console.log("Upload success:", res.data);
        } catch (error) {
            console.error("Upload error:", error);
        }
    };
    const Uploadfilemodal = async () => {
        if (!storefile) {
            toast.error("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", storefile);

        try {
            const res = await axios.post(
                `${baseNodeapiUrl}/shiprocket/cancel_order_rto`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,

                    },
                }
            );
            toast.success(res?.data?.message);

            console.log("Upload success:", res.data);
        } catch (error) {
            console.error("Upload error:", error);
        }
    };
    const Uploadfilecancel = async () => {
        if (!storefile) {
            toast.error("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", storefile);

        try {
            const res = await axios.post(
                `${baseNodeapiUrl}/shiprocket/cancel_order`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,

                    },
                }
            );
            toast.success(res?.data?.message);
            console.log("Upload success:", res.data);
        } catch (error) {
            console.error("Upload error:", error);
        }
    };
    const Uploadfileupdate = async () => {
        if (!storefile) {
            toast.error("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", storefile);

        try {
            const res = await axios.post(
                `${baseNodeapiUrl}/shiprocket/import_order_status_send`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,

                    },
                }
            );
            toast.success(res?.data?.message);
            console.log("Upload success:", res.data);
        } catch (error) {
            console.error("Upload error:", error);
        }
    };

    const [openmodalhandler, setopenmodalhandler] = useState(false)
    const [openmodalcancel, setopenmodalcancel] = useState(false)

    const [showService, setShowService] = useState(false);
    const showAllService = () => {
        setShowService(!showService)
    }


    const [openmodalupdate, setopenmodalupdate] = useState(false)

    return (
        <ThemeMaker>
            <div className="row w-100 m-0 mt-2">
                <div className="col-md-12 mb-3">
                    <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "20px", overflow: "hidden", background: "#ffffff", border: "1px solid #e5e7eb", boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)" }}>
                        {/* Filter Bar */}
                        <div className="card-header bg-white border-bottom py-3 px-4" style={{ borderColor: "#e5e7eb" }}>
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                {/* Left Title */}
                                <h4 className="m-0 font-weight-bold" style={{ color: "#0f172a", fontSize: "20px", letterSpacing: "-0.5px" }}>
                                    Order list
                                </h4>

                                {/* Center Filter Controls */}
                                <div className="d-flex align-items-center flex-wrap gap-3 flex-grow-1 mx-md-3" style={{ maxWidth: "550px", gap: "8px" }}>

                                    {/* Outlined Select Order Status Multi-Select Dropdown */}
                                    <div className="position-relative" ref={statusDropdownRef} style={{ width: "260px" }}>
                                        <fieldset
                                            style={{
                                                border: "1.5px solid #f97316",
                                                borderRadius: "10px",
                                                padding: "2px 10px 4px 10px",
                                                position: "relative",
                                                background: "#fff",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => setStatusDropdownOpen((prev) => !prev)}
                                        >
                                            <legend
                                                style={{
                                                    width: "auto",
                                                    padding: "0 6px",
                                                    margin: 0,
                                                    fontSize: "11px",
                                                    fontWeight: 600,
                                                    color: "#f97316",
                                                    lineHeight: 1
                                                }}
                                            >
                                                Select Order Status
                                            </legend>
                                            <div className="d-flex align-items-center justify-content-between" style={{ minHeight: "26px" }}>
                                                <div className="d-flex flex-wrap align-items-center gap-1 overflow-hidden" style={{ maxWidth: "210px" }}>
                                                    {selectedStatuses.length === 0 ? (
                                                        <span className="text-muted" style={{ fontSize: "13px", userSelect: "none" }}>Select status...</span>
                                                    ) : (
                                                        selectedStatuses.map((st) => (
                                                            <span
                                                                key={st}
                                                                className="badge d-inline-flex align-items-center"
                                                                style={{
                                                                    backgroundColor: "#fff7ed",
                                                                    color: "#c2410c",
                                                                    fontWeight: 600,
                                                                    fontSize: "11px",
                                                                    padding: "3px 8px",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #ffedd5"
                                                                }}
                                                            >
                                                                {st}
                                                                <i
                                                                    className="fas fa-times ml-1 cursor-pointer"
                                                                    style={{ fontSize: "9px", cursor: "pointer" }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleStatusToggle(st);
                                                                    }}
                                                                ></i>
                                                            </span>
                                                        ))
                                                    )}
                                                </div>
                                                <i className={`fas fa-caret-${statusDropdownOpen ? "up" : "down"} ml-1`} style={{ color: "#f97316" }}></i>
                                            </div>
                                        </fieldset>

                                        {/* Dropdown Menu Popup */}
                                        {statusDropdownOpen && (
                                            <div
                                                className="position-absolute w-100 bg-white shadow-lg rounded mt-1 p-2"
                                                style={{ zIndex: 1050, top: "100%", left: 0, borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "0 10px 25px rgba(0, 0, 0, 0.08)" }}
                                            >
                                                <div className="p-1 mb-2 border-bottom">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm border-0 bg-light"
                                                        placeholder="Search status..."
                                                        value={statusSearchTerm}
                                                        onChange={(e) => setStatusSearchTerm(e.target.value)}
                                                        style={{ borderRadius: "6px", fontSize: "13px" }}
                                                    />
                                                </div>
                                                <div style={{ maxHeight: "180px", overflowY: "auto" }}>
                                                    {statusOptions
                                                        .filter((opt) => opt.toLowerCase().includes(statusSearchTerm.toLowerCase()))
                                                        .map((status) => {
                                                            const isChecked = selectedStatuses.includes(status);
                                                            return (
                                                                <div
                                                                    key={status}
                                                                    className="d-flex align-items-center px-2 py-2 rounded cursor-pointer"
                                                                    onClick={() => handleStatusToggle(status)}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        fontSize: "14px",
                                                                        backgroundColor: isChecked ? "#fff7ed" : "transparent"
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        className="mr-2"
                                                                        checked={isChecked}
                                                                        onChange={() => { }}
                                                                        style={{ cursor: "pointer", accentColor: "#f97316" }}
                                                                    />
                                                                    <span className={isChecked ? "font-weight-bold text-dark" : "text-secondary"}>
                                                                        {status}
                                                                    </span>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Search Order ID Input */}
                                    <div className="position-relative flex-grow-1" style={{ minWidth: "200px" }}>
                                        <fieldset
                                            style={{
                                                border: "1.5px solid #f97316",
                                                borderRadius: "10px",
                                                padding: "2px 10px 4px 10px",
                                                position: "relative",
                                                background: "#fff"
                                            }}
                                        >
                                            <legend
                                                style={{
                                                    width: "auto",
                                                    padding: "0 6px",
                                                    margin: 0,
                                                    fontSize: "11px",
                                                    fontWeight: 600,
                                                    color: "#f97316",
                                                    lineHeight: 1
                                                }}
                                            >
                                                Search Order ID
                                            </legend>
                                            <div className="d-flex align-items-center" style={{ minHeight: "26px" }}>
                                                <i className="fas fa-search mr-2" style={{ fontSize: "13px", color: "#f97316" }}></i>
                                                <input
                                                    type="text"
                                                    className="border-0 bg-transparent text-dark w-100 p-0"
                                                    style={{ outline: "none", fontSize: "13px" }}
                                                    placeholder="Enter Order ID..."
                                                    value={searchOrderId}
                                                    onChange={(e) => setSearchOrderId(e.target.value)}
                                                />
                                                {searchOrderId && (
                                                    <i
                                                        className="fas fa-times text-muted cursor-pointer ml-1"
                                                        style={{ cursor: "pointer", fontSize: "12px" }}
                                                        onClick={() => setSearchOrderId("")}
                                                    ></i>
                                                )}
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table Body */}
                        <div className="card-body p-0">
                            {orderisLoading ? (
                                <div className="d-flex justify-content-center align-items-center py-5" style={{ minHeight: "250px" }}>
                                    <CircularProgress style={{ color: "#f97316" }} />
                                </div>
                            ) : orderList.length === 0 ? (
                                <div className="text-center py-5" style={{ minHeight: "250px" }}>
                                    <div className="mb-3">
                                        <i className="fas fa-box-open text-muted" style={{ fontSize: "48px", color: "#cbd5e1" }}></i>
                                    </div>
                                    <h5 className="font-weight-bold text-dark">No Orders Found</h5>
                                    <p className="text-muted small">Try adjusting your status filter or search criteria.</p>
                                </div>
                            ) : (
                                <>
                                    <div className="table-responsive" style={{ overflowX: "auto" }}>
                                        <table className="table table-hover align-middle mb-0" style={{ borderCollapse: "separate", borderSpacing: "0" }}>
                                            <thead>
                                                <tr style={{ backgroundColor: " rgb(249 115 22)", color: "#ffffff", borderBottom: "2px solid #f97316" }}>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold text-center" style={{ fontSize: "13px", letterSpacing: "0.3px", backgroundColor: "rgb(249 115 22)" }}>Serial No.</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold" style={{ fontSize: "13px", letterSpacing: "0.3px", backgroundColor: "rgb(249 115 22)" }}>Order ID</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold" style={{ fontSize: "13px", letterSpacing: "0.3px", backgroundColor: "rgb(249 115 22)" }}>Order Status</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold" style={{ fontSize: "13px", letterSpacing: "0.3px", backgroundColor: "rgb(249 115 22)" }}>Seller Name</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold text-center" style={{ fontSize: "13px", letterSpacing: "0.3px" }}>Ageing (in days)</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold" style={{ fontSize: "13px", letterSpacing: "0.3px" }}>Customer Name</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold text-right" style={{ fontSize: "13px", letterSpacing: "0.3px" }}>Total (In Rs)</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold text-center" style={{ fontSize: "13px", letterSpacing: "0.3px" }}>Payment Status</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold" style={{ fontSize: "13px", letterSpacing: "0.3px" }}>Created Date</th>
                                                    <th className="py-2.5 px-3 border-0 text-white font-weight-bold text-center" style={{ fontSize: "13px", letterSpacing: "0.3px" }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orderList.map((item: any, index: number) => {
                                                    let sellerName =
                                                        item?.seller_name ||
                                                        item?.address?.start?.location?.descriptor?.name ||
                                                        (item?.fulfillments ? (typeof item.fulfillments === "string" ? JSON.parse(item.fulfillments)[0]?.start?.location?.descriptor?.name : item.fulfillments[0]?.start?.location?.descriptor?.name) : "") ||
                                                        "N/A";

                                                    const statusState = (item.order_state || "").toLowerCase();
                                                    let statusBadgeStyle = { backgroundColor: "#fff7ed", color: "#c2410c", border: "1px solid #fed7aa" };
                                                    if (statusState === "completed") {
                                                        statusBadgeStyle = { backgroundColor: "#dcfce7", color: "#15803d", border: "1px solid #bbf7d0" };
                                                    } else if (statusState === "cancelled" || statusState === "canceled") {
                                                        statusBadgeStyle = { backgroundColor: "#fee2e2", color: "#b91c1c", border: "1px solid #fca5a5" };
                                                    } else if (statusState === "created") {
                                                        statusBadgeStyle = { backgroundColor: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe" };
                                                    } else if (statusState === "accepted") {
                                                        statusBadgeStyle = { backgroundColor: "#f0fdf4", color: "#166534", border: "1px solid #bbf7d0" };
                                                    } else if (statusState === "in-progress") {
                                                        statusBadgeStyle = { backgroundColor: "#fff7ed", color: "#c2410c", border: "1px solid #fed7aa" };
                                                    }

                                                    const isPaid = (item.payment_status || item.status || "").toUpperCase() === "PAID";
                                                    const paymentBadgeStyle = isPaid
                                                        ? { backgroundColor: "#dcfce7", color: "#15803d", border: "1px solid #bbf7d0" }
                                                        : { backgroundColor: "#fef3c7", color: "#b45309", border: "1px solid #fde68a" };

                                                    return (
                                                        <tr key={index} style={{ transition: "background-color 0.15s ease-in-out", borderBottom: "1px solid #f1f5f9" }}>
                                                            <td className="text-center text-muted font-weight-medium" style={{ fontSize: "13px", color: "#64748b" }}>
                                                                {(nextstep - 1) * pageSize + index + 1}
                                                            </td>
                                                            <td className="font-weight-bold" style={{ fontSize: "14px", color: "#0f172a" }}>{item.order_id}</td>
                                                            <td>
                                                                <span className="badge px-3 py-2 rounded-pill" style={{ fontSize: "12px", fontWeight: 600, ...statusBadgeStyle }}>
                                                                    {item.order_state}
                                                                </span>
                                                            </td>
                                                            <td style={{ fontSize: "13px", color: "#334155", fontWeight: 500 }}>{sellerName}</td>
                                                            <td className="text-center font-weight-bold" style={{ fontSize: "13px", color: "#0f172a" }}>{item.created_at ? moment().diff(moment(item.created_at), 'days') : 0}</td>
                                                            <td className="font-weight-medium" style={{ fontSize: "13px", color: "#1e293b" }}>{item?.name || "N/A"}</td>
                                                            <td className="text-right font-weight-bold" style={{ fontSize: "14px", color: "#0f172a" }}>₹{item.order_total || 0}</td>
                                                            <td className="text-center">
                                                                <span
                                                                    className="badge px-3 py-1 rounded-pill"
                                                                    style={{ fontSize: "11px", textTransform: "uppercase", fontWeight: 700, ...paymentBadgeStyle }}
                                                                >
                                                                    {item.payment_status || item.status || "N/A"}
                                                                </span>
                                                            </td>
                                                            <td className="text-muted small" style={{ color: "#64748b" }}>{item.created_at ? moment(item.created_at).format("DD-MM-YYYY HH:mm") : "N/A"}</td>

                                                            <td className="text-center">
                                                                <div className="d-flex justify-content-center gap-2" style={{ gap: "6px" }}>
                                                                    {/* Edit - Open Modal */}
                                                                    <span
                                                                        className="btn btn-sm rounded-circle shadow-sm cursor-pointer d-inline-flex align-items-center justify-content-center"
                                                                        onClick={() => getorderDetailsByOrderID(item.order_id)}
                                                                        title="Edit Order"
                                                                        style={{ width: "32px", height: "32px", backgroundColor: "#f97316", color: "#ffffff", border: "none", cursor: "pointer", boxShadow: "0 2px 6px rgba(249, 115, 22, 0.3)" }}
                                                                    >
                                                                        <i className="fas fa-pen" style={{ fontSize: "12px" }}></i>
                                                                    </span>

                                                                    {/* View - Redirect */}
                                                                    <Link
                                                                        to={`/orderCompleteDetail/${item.order_id}`}
                                                                        className="btn btn-sm rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center"
                                                                        title="View Order"
                                                                        style={{ width: "32px", height: "32px", backgroundColor: "#3b82f6", color: "#ffffff", border: "none", boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)" }}
                                                                    >
                                                                        <i className="fas fa-eye" style={{ fontSize: "12px" }}></i>
                                                                    </Link>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination Footer - always visible outside the table scroll */}
                                    <div className="card-footer bg-white border-top py-3 px-4 d-flex flex-wrap justify-content-between align-items-center" style={{ borderColor: "#e5e7eb", gap: "12px" }}>
                                        <div className="d-flex align-items-center flex-wrap" style={{ gap: "12px", fontSize: "13px", color: "#64748B" }}>
                                            <span>
                                                Showing <strong>{totalCount > 0 ? (nextstep - 1) * pageSize + 1 : 0}</strong> to{" "}
                                                <strong>{Math.min(nextstep * pageSize, totalCount)}</strong> of <strong>{totalCount}</strong> entries
                                            </span>
                                            <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                                <span>Rows per page:</span>
                                                <select
                                                    value={pageSize}
                                                    onChange={(e) => {
                                                        const newSize = Number(e.target.value);
                                                        setPageSize(newSize);
                                                        setnextstep(1);
                                                    }}
                                                    style={{
                                                        width: "70px",
                                                        height: "32px",
                                                        padding: "2px 8px",
                                                        fontSize: "13px",
                                                        borderRadius: "6px",
                                                        borderColor: "#CBD5E1",
                                                        cursor: "pointer",
                                                        background: "#F8FAFC",
                                                        color: "#334155",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                            </div>
                                        </div>

                                        {totalPages > 1 && (
                                            <ul className="pagination mb-0 gap-1 flex-wrap" style={{ gap: "4px" }}>
                                                <li className={`page-item ${nextstep === 1 ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link border-0 rounded-lg px-3 py-2"
                                                        style={{ backgroundColor: nextstep === 1 ? "#f1f5f9" : "#ffffff", color: nextstep === 1 ? "#94a3b8" : "#475569", border: "1px solid #e5e7eb", borderRadius: "8px" }}
                                                        onClick={() => {
                                                            setnextstep(1);
                                                        }}
                                                        disabled={nextstep === 1}
                                                    >
                                                        First
                                                    </button>
                                                </li>

                                                {/* Previous Button */}
                                                <li className={`page-item ${nextstep === 1 ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link border-0 rounded-lg px-3 py-2"
                                                        style={{ backgroundColor: nextstep === 1 ? "#f1f5f9" : "#ffffff", color: nextstep === 1 ? "#94a3b8" : "#475569", border: "1px solid #e5e7eb", borderRadius: "8px" }}
                                                        onClick={() => {
                                                            setnextstep(prev => Math.max(prev - 1, 1));
                                                        }}
                                                        disabled={nextstep === 1}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>

                                                {/* Page Numbers */}
                                                {(() => {
                                                    const pages = [];
                                                    const current = nextstep;

                                                    if (current > 3) {
                                                        pages.push(
                                                            <li key="first" className="page-item">
                                                                <button className="page-link" style={{ borderRadius: "8px", border: "1px solid #e5e7eb", color: "#475569" }} onClick={() => setnextstep(1)}>1</button>
                                                            </li>
                                                        );
                                                        if (current > 4) {
                                                            pages.push(
                                                                <li key="ellipsis1" className="page-item disabled">
                                                                    <span className="page-link" style={{ borderRadius: "8px", border: "none" }}>...</span>
                                                                </li>
                                                            );
                                                        }
                                                    }

                                                    const startPage = Math.max(1, current - 2);
                                                    const endPage = Math.min(totalPages, current + 2);

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        const isActive = nextstep === i;
                                                        pages.push(
                                                            <li
                                                                key={i}
                                                                className={`page-item ${isActive ? 'active' : ''}`}
                                                            >
                                                                <button
                                                                    className="page-link"
                                                                    style={{
                                                                        borderRadius: "8px",
                                                                        backgroundColor: isActive ? "#f97316" : "#ffffff",
                                                                        color: isActive ? "#ffffff" : "#475569",
                                                                        borderColor: isActive ? "#f97316" : "#e5e7eb",
                                                                        fontWeight: isActive ? 600 : 400
                                                                    }}
                                                                    onClick={() => setnextstep(i)}
                                                                >
                                                                    {i}
                                                                </button>
                                                            </li>
                                                        );
                                                    }

                                                    if (current < totalPages - 2) {
                                                        if (current < totalPages - 3) {
                                                            pages.push(
                                                                <li key="ellipsis2" className="page-item disabled">
                                                                    <span className="page-link" style={{ borderRadius: "8px", border: "none" }}>...</span>
                                                                </li>
                                                            );
                                                        }
                                                        pages.push(
                                                            <li key="last" className={`page-item ${nextstep === totalPages ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ borderRadius: "8px", border: "1px solid #e5e7eb", color: "#475569" }} onClick={() => setnextstep(totalPages)}>
                                                                    {totalPages}
                                                                </button>
                                                            </li>
                                                        );
                                                    }

                                                    return pages;
                                                })()}

                                                {/* Next Button */}
                                                <li className={`page-item ${nextstep === totalPages ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link border-0 rounded-lg px-3 py-2"
                                                        style={{ backgroundColor: nextstep === totalPages ? "#f1f5f9" : "#ffffff", color: nextstep === totalPages ? "#94a3b8" : "#475569", border: "1px solid #e5e7eb", borderRadius: "8px" }}
                                                        onClick={() => {
                                                            setnextstep(prev => Math.min(prev + 1, totalPages));
                                                        }}
                                                        disabled={nextstep === totalPages}
                                                    >
                                                        Next
                                                    </button>
                                                </li>

                                                {/* Last Button */}
                                                <li className={`page-item ${nextstep === totalPages ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link border-0 rounded-lg px-3 py-2"
                                                        style={{ backgroundColor: nextstep === totalPages ? "#f1f5f9" : "#ffffff", color: nextstep === totalPages ? "#94a3b8" : "#475569", border: "1px solid #e5e7eb", borderRadius: "8px" }}
                                                        onClick={() => {
                                                            setnextstep(totalPages);
                                                        }}
                                                        disabled={nextstep === totalPages}
                                                    >
                                                        Last
                                                    </button>
                                                </li>
                                            </ul>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={openmodalbtn}
                onClose={() => setopenmodalbtn(false)}
                disableEscapeKeyDown={true}
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-3" style={{ position: "relative" }}>

                    {/* Close icon */}
                    <CloseIcon
                        onClick={() => setopenmodalbtn(false)}
                        style={{
                            position: "absolute",
                            top: "14px",
                            right: "14px",
                            cursor: "pointer",
                            fontSize: "22px",
                            color: "#64748b",
                        }}
                    />

                    <div>
                        <h5 className="d-flex justify-content-center fw-bold mb-4" style={{ color: "#0f172a", fontWeight: 700 }}>Upload Excel File (.xlsx)</h5>

                        <input
                            style={{ display: "flex", margin: "auto", marginBottom: "20px" }}
                            type="file"
                            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            onChange={handleFile}
                        />
                    </div>
                    <button className="btn d-flex m-auto text-white font-weight-bold"
                        onClick={Uploadfile}
                        style={{ backgroundColor: "#f97316", borderRadius: "10px", padding: "8px 24px", border: "none", boxShadow: "0 4px 12px rgba(249, 115, 22, 0.25)" }}
                    >
                        Submit
                    </button>
                </Box>
            </Modal>

            <Modal
                open={openmodalhandler}
                onClose={() => setopenmodalhandler(false)}
                disableEscapeKeyDown={true}
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-3" style={{ position: "relative" }}>

                    {/* Close icon */}
                    <CloseIcon
                        onClick={() => setopenmodalhandler(false)}
                        style={{
                            position: "absolute",
                            top: "14px",
                            right: "14px",
                            cursor: "pointer",
                            fontSize: "22px",
                            color: "#64748b",
                        }}
                    />

                    <div>
                        <h5 className="d-flex justify-content-center fw-bold mb-4" style={{ color: "#0f172a", fontWeight: 700 }}>Upload Excel File (.xlsx)</h5>

                        <input
                            style={{ display: "flex", margin: "auto", marginBottom: "20px" }}
                            type="file"
                            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            onChange={handlemodalfile}
                        />
                    </div>
                    <button className="btn d-flex m-auto text-white font-weight-bold"
                        onClick={Uploadfilemodal}
                        style={{ backgroundColor: "#f97316", borderRadius: "10px", padding: "8px 24px", border: "none", boxShadow: "0 4px 12px rgba(249, 115, 22, 0.25)" }}
                    >
                        Submit
                    </button>
                </Box>
            </Modal>

            <Modal
                open={openmodalcancel}
                onClose={() => setopenmodalcancel(false)}
                disableEscapeKeyDown={true}
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-3" style={{ position: "relative" }}>

                    {/* Close icon */}
                    <CloseIcon
                        onClick={() => setopenmodalcancel(false)}
                        style={{
                            position: "absolute",
                            top: "14px",
                            right: "14px",
                            cursor: "pointer",
                            fontSize: "22px",
                            color: "#64748b",
                        }}
                    />

                    <div>
                        <h5 className="d-flex justify-content-center fw-bold mb-4" style={{ color: "#0f172a", fontWeight: 700 }}>Upload Excel File (.xlsx)</h5>

                        <input
                            style={{ display: "flex", margin: "auto", marginBottom: "20px" }}
                            type="file"
                            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            onChange={handlemodalcancel}
                        />
                    </div>
                    <button className="btn d-flex m-auto text-white font-weight-bold"
                        onClick={Uploadfilecancel}
                        style={{ backgroundColor: "#f97316", borderRadius: "10px", padding: "8px 24px", border: "none", boxShadow: "0 4px 12px rgba(249, 115, 22, 0.25)" }}
                    >
                        Submit
                    </button>
                </Box>
            </Modal>

            <Modal
                open={openmodalupdate}
                onClose={() => setopenmodalupdate(false)}
                disableEscapeKeyDown={true}
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-3" style={{ position: "relative" }}>

                    {/* Close icon */}
                    <CloseIcon
                        onClick={() => setopenmodalupdate(false)}
                        style={{
                            position: "absolute",
                            top: "14px",
                            right: "14px",
                            cursor: "pointer",
                            fontSize: "22px",
                            color: "#64748b",
                        }}
                    />

                    <div>
                        <h5 className="d-flex justify-content-center fw-bold mb-4" style={{ color: "#0f172a", fontWeight: 700 }}>Upload Excel File (.xlsx)</h5>

                        <input
                            style={{ display: "flex", margin: "auto", marginBottom: "20px" }}
                            type="file"
                            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            onChange={handlemodalupdate}
                        />
                    </div>
                    <button className="btn d-flex m-auto text-white font-weight-bold"
                        onClick={Uploadfileupdate}
                        style={{ backgroundColor: "#f97316", borderRadius: "10px", padding: "8px 24px", border: "none", boxShadow: "0 4px 12px rgba(249, 115, 22, 0.25)" }}
                    >
                        Submit
                    </button>
                </Box>
            </Modal>

            <Modal
                open={exportOrderModalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-3 w-75 w-md-25">

                    <div className="modal-content border-0">
                        <div className="modal-header p-3 d-flex align-items-center justify-content-between border-bottom">
                            <p className="modal-title font-weight-bold m-0" style={{ color: "#0f172a", letterSpacing: "1px", fontSize: "16px" }}>Export Orders:</p>
                            <button type="button" className="close border-0 bg-transparent" data-dismiss="modal" aria-label="Close">
                                <span style={{ cursor: "pointer" }}><CloseIcon onClick={handleExportOrderModalClose} style={{ color: "#64748b" }} /></span>
                            </button>
                        </div>
                        <div className="mb-3 d-flex flex-column gap-2 mt-3 px-3"
                            style={{ borderRadius: "8px", borderColor: "#e5e7eb" }}
                        >
                            <label className="font-weight-bold small text-muted">Start Date</label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                placeholderText="Pick start date"
                                className="form-control rounded-lg"


                            />
                        </div>

                        <div className="mb-3 d-flex flex-column gap-2 mt-2 px-3"
                            style={{ borderRadius: "8px", borderColor: "#e5e7eb" }}

                        >
                            <label className="font-weight-bold small text-muted">End Date</label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                placeholderText="Pick end date"
                                className="form-control rounded-lg"
                                minDate={startDate || undefined}

                            />
                        </div>

                        <div className="modal-footer border-top p-3">
                            <button
                                type="button"
                                disabled={exportDisabled}
                                className="btn text-white font-weight-bold w-100"
                                onClick={allorderList}
                                style={{ backgroundColor: exportDisabled ? "#cbd5e1" : "#f97316", borderRadius: "10px", border: "none", padding: "10px" }}
                            >
                                {isDisabled ? "Pick the date" : "Export Orders"}
                            </button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={updateorderstatus}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-3 w-75 w-md-25">

                    <div className="d-flex flex-column gap-2 p-2">
                        <button
                            className="btn text-white font-weight-bold mb-2"
                            onClick={() => updatetrackingurl()}
                            style={{ backgroundColor: "#f97316", borderRadius: "10px", letterSpacing: "0.5px", padding: "10px", border: "none" }}
                        >
                            Update Tracking Url
                        </button>

                        <button
                            className="btn text-white font-weight-bold mb-2"
                            title="Update Url Using Shopify"
                            onClick={() => updateordershopify()}
                            style={{ backgroundColor: "#f97316", borderRadius: "10px", letterSpacing: "0.5px", padding: "10px", border: "none" }}
                        >
                            Update Order
                        </button>

                        <button
                            className="btn text-white font-weight-bold"
                            title="Update Order Using Tracking Url"
                            onClick={() => updateordertrack()}
                            style={{ backgroundColor: "#f97316", borderRadius: "10px", letterSpacing: "0.5px", padding: "10px", border: "none" }}
                        >
                            Update Order
                        </button>
                    </div>

                    <div className="text-center mt-2">
                        <button
                            className="btn btn-light text-secondary font-weight-bold px-4"
                            onClick={() => setupdateorderstatus(false)}
                            style={{ borderRadius: "10px" }}
                        >
                            Close
                        </button>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={shipmentModalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-3 w-75 w-md-25">

                    <div className="modal-content border-0">
                        <div className="modal-header p-3 d-flex align-items-center justify-content-between border-bottom">
                            <p className="modal-title font-weight-bold m-0" style={{ color: "#0f172a", letterSpacing: "1px", fontSize: "16px" }}>Filters:</p>
                            <button type="button" className="close border-0 bg-transparent" data-dismiss="modal" aria-label="Close">
                                <span style={{ cursor: "pointer" }}><CloseIcon onClick={handleShipementModalClose} style={{ color: "#64748b" }} /></span>
                            </button>
                        </div>
                        <div className="modal-body p-3">
                            <div>
                                <select name="seller_id" id="" className="form-control" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} value={filterDaata.seller_id} onChange={filterChangeHandler}>
                                    <option value="" disabled selected>Select Seller</option>
                                    {
                                        sellerList.map((item: any) => (
                                            <option value={item?.seller_id} key={item?.seller_id}>{item?.name}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className="mt-3">
                                <select
                                    name="orderCurrentStatus"
                                    className="form-control"
                                    style={{ borderRadius: "8px", borderColor: "#e5e7eb" }}
                                    value={Array.isArray(filterDaata.orderCurrentStatus) ? filterDaata.orderCurrentStatus[0] || "" : filterDaata.orderCurrentStatus || ""}
                                    onChange={filterChangeHandler}
                                >
                                    <option value="">Select Order Status</option>
                                    <option value="Created">Created</option>
                                    <option value="Accepted">Accepted</option>
                                    <option value="In-progress">In-progress</option>
                                    <option value="Completed">Completed</option>
                                    <option value="Cancelled">Cancelled</option>
                                </select>
                            </div>

                            <div className="mt-3">
                                <input type="date" name="endDate" className="form-control" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} max={getCurrentDate()} value={filterDaata.endDate} onChange={filterChangeHandler} />
                            </div>
                        </div>
                        <div className="modal-footer border-top p-3 d-flex justify-content-between">
                            <button type="button" className="btn btn-outline-danger" style={{ borderRadius: "8px" }} onClick={() => {
                                fetchSellerList(); setshipmentModalOpen(false); setfilterDaata({
                                    seller_id: "",
                                    orderCurrentStatus: "",
                                    endDate: ""
                                })
                            }}>Clear Filter</button>
                            <button type="button" className="btn text-white font-weight-bold" style={{ backgroundColor: "#f97316", borderRadius: "8px", border: "none" }} data-dismiss="modal" onClick={applyFilterHandler}>Apply Changes</button>
                        </div>
                    </div>
                </Box>
            </Modal>

            {/* ------------------ FRAUD MODAL -------------------------- */}
            <Modal
                open={fraudModalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-3 w-75 w-md-25">

                    <div className="modal-content border-0">
                        <div className="modal-header p-3 d-flex align-items-center justify-content-between border-bottom">
                            <p className="modal-title font-weight-bold m-0" style={{ color: "#0f172a", letterSpacing: "1px", fontSize: "16px" }}>Fraud Analysis:</p>
                            <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                                {(fraudDaata.provider_id && fraudDaata.limit_count) && <span className="d-block text-center" style={{ width: "60px", padding: "2px", cursor: "pointer", borderRadius: "20px", fontSize: "12px", background: "#f1f5f9", color: "#475569", fontWeight: 600 }} onClick={() => {
                                    setfraudDaata({
                                        provider_id: "",
                                        start_date: "",
                                        end_date: "",
                                        limit_count: "",
                                        limit_price: ""
                                    });
                                    setfraudLevel("")
                                }}>Clear</span>}

                                <button type="button" className="close border-0 bg-transparent" data-dismiss="modal" aria-label="Close">
                                    <span style={{ cursor: "pointer" }}><CloseIcon onClick={handleFraudModalClose} style={{ color: "#64748b" }} /></span>
                                </button>
                            </div>
                        </div>
                        <div className="modal-body p-3">
                            <div>
                                <label htmlFor="" className="font-weight-bold small text-dark">Choose Seller <span className="text-danger">*</span></label>
                                <select name="provider_id" id="" className="form-control" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} value={fraudDaata.provider_id} onChange={fraudChangeHandler}>
                                    <option value="" disabled selected>Select Seller</option>
                                    {
                                        sellerList.map((item: any) => (
                                            <option value={item?.provider_id} key={item?.seller_id}>{item?.name}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className="mt-2">
                                <label htmlFor="" className="font-weight-bold small text-dark">Order Limit <span className="text-danger">*</span></label>
                                <input type="number" min={0} onKeyPress={preventMinus} value={fraudDaata.limit_count} name="limit_count" className="form-control" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} onChange={fraudChangeHandler} />
                            </div>
                            <div className="mt-2">
                                <label htmlFor="" className="font-weight-bold small text-dark">Price Limit <span className="text-danger">*</span></label>
                                <input type="number" min={0} onKeyPress={preventMinus} value={fraudDaata.limit_price} name="limit_price" className="form-control" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} onChange={fraudChangeHandler} />
                            </div>

                            <div className="mt-2">
                                <label htmlFor="" className="font-weight-bold small text-dark">Start Date <span className="text-danger">*</span></label>
                                <input type="date" value={fraudDaata.start_date} name="start_date" className="form-control" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} max={getCurrentDate()} onChange={fraudChangeHandler} />
                            </div>
                            <div className="mt-2">
                                <label htmlFor="" className="font-weight-bold small text-dark">End Date <span className="text-danger">*</span></label>
                                <input type="date" value={fraudDaata.end_date} name="end_date" className="form-control" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} max={getCurrentDate()} onChange={fraudChangeHandler} />
                            </div>
                        </div>
                        <div className="modal-footer border-top p-3 justify-content-between">
                            <button type="button" className="btn text-white font-weight-bold px-4" style={{ backgroundColor: "#f97316", borderRadius: "8px", border: "none" }} data-dismiss="modal" onClick={analyzerFunction} disabled={(fraudDaata.end_date && fraudDaata.start_date && fraudDaata.limit_count && fraudDaata.limit_price && fraudDaata.provider_id) ? false : true}>{isAnalyzing ? "Please Wait.." : "Analyze"}</button>

                            {fraudLevel !== "" && <div style={{ width: "60%" }}>
                                <div>
                                    <div className="progress" style={{ borderRadius: "10px", height: "10px" }}>
                                        <div className="progress-bar" role="progressbar" style={{ width: `${fraudLevel}`, backgroundColor: "#22c55e" }} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}></div>
                                    </div>
                                    <div className="d-flex justify-content-around mt-2">
                                        {steps.map(item => {
                                            return <span className="small text-muted" key={item}>{item}</span>
                                        })}
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </Box>
            </Modal>

            {/* ------------------ ORDER UPDATE MODAL -------------------------- */}
            <Modal
                open={orderUpdateModal}
                onClose={() => {
                    setorderUpdateModal(false);
                    handleOrderUpdateModalClose();
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...Sstyle, borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 20px 40px rgba(15, 23, 42, 0.15)" }} className="col-md-4">
                    <div className="modal-content border-0">
                        <div className="modal-header p-3 d-flex align-items-center justify-content-between border-bottom">
                            <p className="modal-title font-weight-bold m-0" style={{ color: "#0f172a", letterSpacing: "0.5px", fontSize: "16px" }}>Order ID : {orderState.order_id}</p>
                            <button type="button" className="close border-0 bg-transparent" data-dismiss="modal" aria-label="Close">
                                <span style={{ cursor: "pointer" }}><CloseIcon onClick={() => {
                                    setorderUpdateModal(false);
                                    handleOrderUpdateModalClose();
                                }} style={{ color: "#64748b" }} /></span>
                            </button>
                        </div>
                        <div className="modal-body p-3">
                            {orderState?.order_state !== "Cancelled" ? <div>
                                <div>
                                    <label className="font-weight-bold small text-dark">Order Status</label>
                                    <select className="form-control mt-1" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} value={orderState?.order_state} onChange={(e) => {
                                        setOrderState((prev) => {
                                            return { ...prev, order_state: e.target.value }
                                        })
                                    }}>
                                        <option value="" disabled selected>Select Order Status</option>
                                        {orderStatus.map((item) => {
                                            return <option value={item} key={item}>{item}</option>
                                        })}
                                    </select>
                                </div>

                                <div className="mt-3">
                                    <label className="font-weight-bold small text-dark">Fulfillment Status</label>
                                    <select className="form-control mt-1" style={{ borderRadius: "8px", borderColor: "#e5e7eb" }} value={orderState?.fulfillment_state} onChange={(e) => {
                                        setOrderState((prev) => {
                                            return { ...prev, fulfillment_state: e.target.value }
                                        })
                                    }}>
                                        <option value="">Select Fulfillment Status</option>
                                        {(orderState?.order_state === "Created" || orderState?.order_state === "Accepted") && <option value="Pending">Pending</option>}

                                        {orderState?.order_state === "In-progress" &&
                                            <>
                                                <option value="Packed">Packed</option>
                                                <option value="Agent-assigned">Agent-assigned</option>
                                                <option value="Order-picked-up">Order-picked-up</option>
                                                <option value="Out-for-delivery">Out-for-delivery</option>
                                            </>}
                                        {orderState?.order_state == "Completed" && <option value="Order-delivered">Delivered</option>}
                                    </select>
                                </div>

                                {orderState?.fulfillment_state === "Agent-assigned" && (
                                    <>
                                        <div className="mt-3">
                                            <label className="font-weight-bold small text-dark">
                                                Agent Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control mt-1"
                                                maxLength={50}
                                                style={{
                                                    borderRadius: "8px",
                                                    borderColor: fieldErrors.agent_name ? "#ef4444" : "#e5e7eb",
                                                    backgroundColor: isAgentNameReadOnly ? "#f1f5f9" : "#ffffff",
                                                    cursor: isAgentNameReadOnly ? "not-allowed" : "text",
                                                    color: isAgentNameReadOnly ? "#64748b" : "#0f172a"
                                                }}
                                                placeholder="Enter Agent Name"
                                                value={orderState?.agent_name}
                                                disabled={isAgentNameReadOnly}
                                                readOnly={isAgentNameReadOnly}
                                                onChange={(e) => {
                                                    if (!isAgentNameReadOnly) {
                                                        setOrderState((prev: any) => ({
                                                            ...prev,
                                                            agent_name: e.target.value
                                                        }));
                                                        if (fieldErrors.agent_name) {
                                                            setFieldErrors((prev) => ({ ...prev, agent_name: undefined }));
                                                        }
                                                    }
                                                }}
                                            />
                                            {fieldErrors.agent_name && (
                                                <small className="text-danger d-block mt-1 font-weight-bold" style={{ fontSize: "11px" }}>
                                                    {fieldErrors.agent_name}
                                                </small>
                                            )}
                                        </div>

                                        <div className="mt-3">
                                            <label className="font-weight-bold small text-dark">
                                                Agent Contact <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control mt-1"
                                                style={{
                                                    borderRadius: "8px",
                                                    borderColor: fieldErrors.agent_contact ? "#ef4444" : "#e5e7eb",
                                                    backgroundColor: isAgentContactReadOnly ? "#f1f5f9" : "#ffffff",
                                                    cursor: isAgentContactReadOnly ? "not-allowed" : "text",
                                                    color: isAgentContactReadOnly ? "#64748b" : "#0f172a"
                                                }}
                                                placeholder="Enter 10-digit Agent Contact"
                                                value={orderState?.agent_contact}
                                                maxLength={10}
                                                disabled={isAgentContactReadOnly}
                                                readOnly={isAgentContactReadOnly}
                                                onKeyPress={(e) => {
                                                    // Block non-digits
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                        return;
                                                    }
                                                    // Block 1-5 as the first digit
                                                    const currentVal = orderState?.agent_contact || "";
                                                    if (currentVal.length === 0 && /^[1-5]$/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    if (!isAgentContactReadOnly) {
                                                        const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 10);
                                                        // First digit must be 6, 7, 8, or 9
                                                        if (onlyDigits.length > 0 && !/^[6-9]/.test(onlyDigits)) return;
                                                        setOrderState((prev: any) => ({
                                                            ...prev,
                                                            agent_contact: onlyDigits
                                                        }));
                                                        if (fieldErrors.agent_contact) {
                                                            setFieldErrors((prev) => ({ ...prev, agent_contact: undefined }));
                                                        }
                                                    }
                                                }}
                                            />
                                            {fieldErrors.agent_contact && (
                                                <small className="text-danger d-block mt-1 font-weight-bold" style={{ fontSize: "11px" }}>
                                                    {fieldErrors.agent_contact}
                                                </small>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div> : <p className="text-center text-danger font-weight-bold my-3">This Order has been cancelled!</p>}
                        </div>

                        {orderState?.order_state !== "Cancelled" ? <div className="modal-footer border-top p-3 d-flex justify-content-between align-items-center gap-2">
                            {orderState?.fulfillment_state === "Agent-assigned" ? (
                                <div style={{ flex: 1 }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{
                                            borderRadius: "8px",
                                            borderColor: (fieldErrors.tracking_url || (orderState?.tracking_url && !orderState?.tracking_url.startsWith("https://"))) ? "#ef4444" : "#e5e7eb",
                                            backgroundColor: isTrackingUrlReadOnly ? "#f1f5f9" : "#ffffff",
                                            cursor: isTrackingUrlReadOnly ? "not-allowed" : "text",
                                            color: isTrackingUrlReadOnly ? "#64748b" : "#0f172a"
                                        }}
                                        placeholder="Tracking Url (https://...) *"
                                        name="tracking_url"
                                        required={orderState?.fulfillment_state === "Agent-assigned"}
                                        value={orderState?.tracking_url}
                                        disabled={isTrackingUrlReadOnly}
                                        readOnly={isTrackingUrlReadOnly}
                                        onChange={(e) => {
                                            if (!isTrackingUrlReadOnly) {
                                                setOrderState((prev: any) => ({
                                                    ...prev,
                                                    tracking_url: e.target.value
                                                }));
                                                if (fieldErrors.tracking_url) {
                                                    setFieldErrors((prev) => ({ ...prev, tracking_url: undefined }));
                                                }
                                            }
                                        }}
                                    />
                                    {fieldErrors.tracking_url ? (
                                        <small className="text-danger d-block mt-1 font-weight-bold" style={{ fontSize: "11px" }}>
                                            {fieldErrors.tracking_url}
                                        </small>
                                    ) : orderState?.tracking_url && !orderState?.tracking_url.startsWith("https://") ? (
                                        <small className="text-danger d-block mt-1 font-weight-bold" style={{ fontSize: "11px" }}>
                                            Tracking URL must start with https://
                                        </small>
                                    ) : null}
                                </div>
                            ) : <div />}

                            <button className="btn text-white font-weight-bold px-4" style={{ backgroundColor: "rgb(249 115 22)", borderRadius: "8px", border: "none", whiteSpace: "nowrap" }} onClick={updateThisOrder}>Update</button>
                        </div> : null}
                    </div>
                </Box>
            </Modal>
        </ThemeMaker>
    )
}

export default OrderList;

// export default OrderList;
